import { MD1 } from './1.MD';
import { MS1 } from './1.MS';
import { MD2 } from './2.MD';
import { WD } from './WD';
import { XD } from './XD';
import { MS2 } from './2.MS';
import { MS3 } from './3.MS';
import { WS } from './WS';

export const getTestData = (modeString: string) => {
    switch (modeString) {
        case '1.MD':
            return MD1;
        case '1.MS':
            return MS1;
        case '2.MD':
            return MD2;
        case 'WD':
            return WD;
        case 'XD':
            return XD;
        case '2.MS':
            return MS2;
        case '3.MS':
            return MS3;
        case 'WS':
            return WS;
    }
};